// Mapping country names to ISO codes for flags
const countryNameToCode: Record<string, string> = {
  // Main countries
  'United States': 'us',
  'United Kingdom': 'gb',
  'Russian Federation': 'ru',
  'Germany': 'de',
  'France': 'fr',
  'Italy': 'it',
  'Spain': 'es',
  'Netherlands': 'nl',
  'Belgium': 'be',
  'Switzerland': 'ch',
  'Austria': 'at',
  'Sweden': 'se',
  'Norway': 'no',
  'Denmark': 'dk',
  'Finland': 'fi',
  'Poland': 'pl',
  'Czech Republic': 'cz',
  'Hungary': 'hu',
  'Romania': 'ro',
  'Bulgaria': 'bg',
  'Croatia': 'hr',
  'Slovenia': 'si',
  'Slovakia': 'sk',
  'Lithuania': 'lt',
  'Latvia': 'lv',
  'Estonia': 'ee',
  'Ireland': 'ie',
  'Portugal': 'pt',
  'Greece': 'gr',
  'Turkey': 'tr',
  'Ukraine': 'ua',
  'Belarus': 'by',
  'Moldova': 'md', // Main issue
  'Moldova, Republic of': 'md',
  'Republic of Moldova': 'md',
  'Canada': 'ca',
  'Mexico': 'mx',
  'Brazil': 'br',
  'Argentina': 'ar',
  'Chile': 'cl',
  'Colombia': 'co',
  'Peru': 'pe',
  'Venezuela': 've',
  'Ecuador': 'ec',
  'Bolivia': 'bo',
  'Paraguay': 'py',
  'Uruguay': 'uy',
  'China': 'cn',
  'Japan': 'jp',
  'South Korea': 'kr',
  'North Korea': 'kp',
  'India': 'in',
  'Pakistan': 'pk',
  'Bangladesh': 'bd',
  'Sri Lanka': 'lk',
  'Nepal': 'np',
  'Bhutan': 'bt',
  'Maldives': 'mv',
  'Afghanistan': 'af',
  'Iran': 'ir',
  'Iraq': 'iq',
  'Israel': 'il',
  'Palestine': 'ps',
  'Jordan': 'jo',
  'Lebanon': 'lb',
  'Syria': 'sy',
  'Saudi Arabia': 'sa',
  'United Arab Emirates': 'ae',
  'Kuwait': 'kw',
  'Qatar': 'qa',
  'Bahrain': 'bh',
  'Oman': 'om',
  'Yemen': 'ye',
  'Egypt': 'eg',
  'Libya': 'ly',
  'Tunisia': 'tn',
  'Algeria': 'dz',
  'Morocco': 'ma',
  'Sudan': 'sd',
  'South Sudan': 'ss',
  'Ethiopia': 'et',
  'Kenya': 'ke',
  'Uganda': 'ug',
  'Tanzania': 'tz',
  'Rwanda': 'rw',
  'Burundi': 'bi',
  'Madagascar': 'mg',
  'Mauritius': 'mu',
  'Seychelles': 'sc',
  'Comoros': 'km',
  'Djibouti': 'dj',
  'Somalia': 'so',
  'Eritrea': 'er',
  'Ghana': 'gh',
  'Nigeria': 'ng',
  'Cameroon': 'cm',
  'Central African Republic': 'cf',
  'Chad': 'td',
  'Niger': 'ne',
  'Mali': 'ml',
  'Burkina Faso': 'bf',
  'Senegal': 'sn',
  'Gambia': 'gm',
  'Guinea-Bissau': 'gw',
  'Guinea': 'gn',
  'Sierra Leone': 'sl',
  'Liberia': 'lr',
  'Ivory Coast': 'ci',
  'Togo': 'tg',
  'Benin': 'bj',
  'Cape Verde': 'cv',
  'São Tomé and Príncipe': 'st',
  'Equatorial Guinea': 'gq',
  'Gabon': 'ga',
  'Republic of the Congo': 'cg',
  'Democratic Republic of the Congo': 'cd',
  'Angola': 'ao',
  'Zambia': 'zm',
  'Zimbabwe': 'zw',
  'Botswana': 'bw',
  'Namibia': 'na',
  'South Africa': 'za',
  'Lesotho': 'ls',
  'Swaziland': 'sz',
  'Malawi': 'mw',
  'Mozambique': 'mz',
  'Australia': 'au',
  'New Zealand': 'nz',
  'Papua New Guinea': 'pg',
  'Fiji': 'fj',
  'Solomon Islands': 'sb',
  'Vanuatu': 'vu',
  'New Caledonia': 'nc',
  'French Polynesia': 'pf',
  'Samoa': 'ws',
  'Tonga': 'to',
  'Kiribati': 'ki',
  'Tuvalu': 'tv',
  'Nauru': 'nr',
  'Palau': 'pw',
  'Marshall Islands': 'mh',
  'Micronesia': 'fm',
  'Indonesia': 'id',
  'Malaysia': 'my',
  'Singapore': 'sg',
  'Thailand': 'th',
  'Vietnam': 'vn',
  'Cambodia': 'kh',
  'Laos': 'la',
  'Myanmar': 'mm',
  'Philippines': 'ph',
  'Brunei': 'bn',
  'East Timor': 'tl',
  'Mongolia': 'mn',
  'Kazakhstan': 'kz',
  'Uzbekistan': 'uz',
  'Turkmenistan': 'tm',
  'Tajikistan': 'tj',
  'Kyrgyzstan': 'kg',
  'Georgia': 'ge',
  'Armenia': 'am',
  'Azerbaijan': 'az',
  'Cyprus': 'cy',
  'Malta': 'mt',
  'Iceland': 'is',
  'Greenland': 'gl',
  'Faroe Islands': 'fo',
  'Luxembourg': 'lu',
  'Monaco': 'mc',
  'Liechtenstein': 'li',
  'San Marino': 'sm',
  'Vatican City': 'va',
  'Andorra': 'ad',
  'Albania': 'al',
  'Bosnia and Herzegovina': 'ba',
  'Montenegro': 'me',
  'Serbia': 'rs',
  'North Macedonia': 'mk',
  'Kosovo': 'xk'
};

/**
 * Converts country name or country code to correct code for flag
 * @param country - country name or country code
 * @returns country code in lowercase for use in flag path
 */
export const getCountryCodeForFlag = (country: string | undefined | null): string => {
  if (!country) return '';
  
  const trimmedCountry = country.trim();
  
  // If it's already a country code (2 characters), return in lowercase
  if (trimmedCountry.length === 2) {
    return trimmedCountry.toLowerCase();
  }
  
  // Search in country name mapping
  const countryCode = countryNameToCode[trimmedCountry];
  if (countryCode) {
    return countryCode;
  }
  
  // If not found, try to find by partial match
  const partialMatch = Object.keys(countryNameToCode).find(name => 
    name.toLowerCase().includes(trimmedCountry.toLowerCase()) ||
    trimmedCountry.toLowerCase().includes(name.toLowerCase())
  );
  
  if (partialMatch) {
    return countryNameToCode[partialMatch];
  }
  
  // If nothing found, return original value in lowercase
  // (might be correct code but in different format)
  return trimmedCountry.toLowerCase();
};
